var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"down"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.finishDesign}},[_vm._v("完成设计")]),_c('el-button',{on:{"click":_vm.cancelDesign}},[_vm._v("取消")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }